import Loadable from 'react-loadable';

export const RedocContainer = Loadable({
  loader: () => import('./RedocContainer'),
  loading: () => null,
});


// WEBPACK FOOTER //
// ./src/containers/RedocContainer/index.tsx